import routerBase from "@nextories/vue-tasks/src/router";
import { createRouter, createWebHistory } from "vue-router";

const AppRoutes = {
  Home: () => import('@/views/Home.vue'),
  Project: () => import('@/views/Project.vue'),
  Diary: () => import('@/views/Diary.vue'),
};

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routerBase.routes().concat([
    {
      path: "/",
      name: "home",
      component: AppRoutes.Home,
      meta: {
        layout: "nxt-tasks-full-layout",
        authRequired: true,
        displayExpandLeftSidebar: true,
        checkRefreshCounters: true,
      },
      beforeEnter: routerBase.isLogged,
    },
    {
      path: "/projects/:id",
      name: "project",
      meta: {
        layout: "nxt-tasks-full-layout",
        authRequired: true,
        hideSidebar: true,
        displayExpandRightSidebar: true,
      },
      beforeEnter: routerBase.isLogged,
      component: AppRoutes.Project,
    },
    {
      path: '/diary',
      name: 'diary',
      component: AppRoutes.Diary,
      meta: {
        layout: 'nxt-tasks-full-layout',
        authRequired: true,
        hideSidebar: true,
      },
      beforeEnter: routerBase.isLogged,
    },
  ]),
});

export default router;
